import { messageTemplateVariables } from 'ai-constants'

export const buildMessageTemplateNestedPaths = (
  data: typeof messageTemplateVariables,
): string[] => {
  const result: string[] = []
  for (const item of data) {
    if (item.paths) {
      const paths = buildMessageTemplateNestedPaths(item.paths as any)
      for (const path of paths) {
        result.push(`${item.group}.${path}`)
      }
    } else {
      result.push((item as any).path)
    }
  }
  return result
}
